import { render, staticRenderFns } from "./SalesCustomerNoActivityTable.vue?vue&type=template&id=3589fb4d"
import script from "./SalesCustomerNoActivityTable.vue?vue&type=script&lang=ts"
export * from "./SalesCustomerNoActivityTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports